module.exports = __webpack_public_path__ + "img/posologie-mathild-synthese-2.b86a2b94.png";